var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.95 3.80998C30.8352 3.29324 30.5202 2.84308 30.0741 2.55816C29.628 2.27325 29.0871 2.17681 28.57 2.28998L20.99 3.97998L10.99 1.97998L2.57001 3.84998C2.12461 3.94615 1.72571 4.19225 1.43996 4.54717C1.1542 4.90209 0.998901 5.34432 1.00001 5.79998V27.75C0.999997 27.8981 1.01677 28.0457 1.05001 28.19C1.16481 28.7067 1.47978 29.1569 1.9259 29.4418C2.37203 29.7267 2.9129 29.8232 3.43001 29.71L11.01 28.02L21.01 30.02L29.43 28.15C29.8754 28.0538 30.2743 27.8077 30.5601 27.4528C30.8458 27.0979 31.0011 26.6556 31 26.2V4.24998C30.9998 4.10191 30.983 3.95433 30.95 3.80998ZM12 4.21998L20 5.81998V27.78L12 26.18V4.21998ZM3.00001 27.75V5.79998L10 4.24998V26.2L3.00001 27.75ZM29 26.2L22 27.75V5.79998L29 4.24998V26.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location-icon.a2138e7a35fd5ded64b0b8bfc19f3de6.svg";
export { ForwardRef as ReactComponent };